import { createApp, h } from "vue";
import axios from "axios";
import { createInertiaApp, Link, Head } from "@inertiajs/inertia-vue3";
import { InertiaProgress } from "@inertiajs/progress";
import { createPinia } from "pinia";

InertiaProgress.init();

// import i18n from "./i18n";
// i18n.setup();

import CKEditor from "@mayasabha/ckeditor4-vue3";

import {
    plugin as formKitPlugin,
    defaultConfig,
    createInput,
} from "@formkit/vue";

import { en, fr } from "@formkit/i18n";

/* import the fontawesome core */
import { library } from "@fortawesome/fontawesome-svg-core";

/* import font awesome icon component */
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

/* import specific icons */
import {
    faPen,
    faTrash,
    faChevronDown,
    faUpload,
    faImage,
    faFile,
    faUpDownLeftRight,
    faListUl,
    faPaperPlane,
    faEye,
} from "@fortawesome/free-solid-svg-icons";
library.add(
    faPen,
    faTrash,
    faChevronDown,
    faUpload,
    faImage,
    faFile,
    faUpDownLeftRight,
    faListUl,
    faPaperPlane,
    faEye
);

import DatePicker from "@inertia/Components/Forms/Inputs/DatePicker";
import Switch from "@inertia/Components/Forms/Inputs/Switch";
import RichText from "@inertia/Components/Forms/Inputs/RichText";
import File from "@inertia/Components/Forms/Inputs/File";
import MultiSelect from "@inertia/Components/Forms/Inputs/MultiSelect";
import TreeSelect from "@inertia/Components/Forms/Inputs/TreeSelect";
import Test from "@inertia/Components/Forms/Inputs/Test";
import TranslatableFields from "@inertia/Components/Forms/TranslatableFields";

import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";

import Layout from "@inertia/Layout/Layout";

axios.defaults["xsrfHeaderName"] = "X-CSRF-Token";
axios.defaults.withCredentials = true;
axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

const config = require("./config.json");
const navigation = require("./navigation.json");

createInertiaApp({
    resolve: async (name) => {
        let page = (await import(`./Pages/${name}`)).default;

        page.layout ??= Layout;

        return page;
    },
    setup({ el, App, props, plugin }) {
        const app = createApp({
            render: () => h(App, props),
        })
            // .use(i18n.vueI18n)
            .use(createPinia())
            .use(plugin)
            .use(Toast)
            .use(CKEditor)
            .use(
                formKitPlugin,
                defaultConfig({
                    // theme: "genesis",
                    // Define additional locales
                    locales: { en, fr },
                    // Define the active locale
                    locale: "fr",
                    inputs: {
                        datepicker: createInput(DatePicker),
                        switch: createInput(Switch, {
                            props: ["on_label", "off_label"],
                        }),
                        richtext: createInput(RichText),
                        file: createInput(File, {
                            props: ["file_path", "file_type", "delete_url"],
                        }),
                        multiselect: createInput(MultiSelect, {
                            props: [
                                "mode",
                                "options",
                                "valueCallback",
                                "optionsCallback",
                            ],
                        }),
                        treeselect: createInput(TreeSelect, {
                            props: [
                                "placeholder",
                                "options",
                                "valueCallback",
                                "optionsCallback",
                            ],
                        }),
                        test: createInput(Test),
                    },
                })
            )
            .component("TranslatableFieldsComponent", TranslatableFields)
            .component("font-awesome-icon", FontAwesomeIcon)
            .component("Link", Link)
            .component("Head", Head);

        app.config.globalProperties.config = config;
        app.config.globalProperties.navigation = navigation;

        app.mount(el);
    },
    title: (title) => title + " | " + config.title,
});
